import React, { useState } from 'react'
import { Container, Row, Tab, Tabs } from 'react-bootstrap'
import Enter from '../enter/enter';
const MainEmp = ({userData}) => {
    const [key, setKey] = useState("enter");
  return (
    <div className="main">
    <Container>
        <h4 className='text-center'>إدارة الموظفين</h4>
      <Row>
        <div className="col-md-12">
          <Tabs
            id="controlled-tab-example" 
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            <Tab eventKey="enter" title="بيانات موظف">
             <Enter userData={userData}/>
            </Tab>
            {/* <Tab eventKey="display" title="عرض">
            <Display/>
                </Tab> */}
          </Tabs>
        </div>
      </Row>
    </Container>
  </div>
  )
}

export default MainEmp